/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_bookmark__iti_save_error__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Versuchen Sie es später noch einmal`
};

const en_bookmark__iti_save_error__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Please try again`
};

const es_bookmark__iti_save_error__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Inténtalo de nuevo`
};

const fr_bookmark__iti_save_error__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Réessayer`
};

const it_bookmark__iti_save_error__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Riprova`
};

const nl_bookmark__iti_save_error__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Probeer het opnieuw`
};

const pt_bookmark__iti_save_error__cta = /** @type {(inputs: {}) => string} */ () => {
	return `Tente novamente`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__iti_save_error__cta = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bookmark__iti_save_error__cta(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("bookmark__iti_save_error__cta", locale)
	if (locale === "de") return de_bookmark__iti_save_error__cta(inputs)
	if (locale === "en") return en_bookmark__iti_save_error__cta(inputs)
	if (locale === "es") return es_bookmark__iti_save_error__cta(inputs)
	if (locale === "fr") return fr_bookmark__iti_save_error__cta(inputs)
	if (locale === "it") return it_bookmark__iti_save_error__cta(inputs)
	if (locale === "nl") return nl_bookmark__iti_save_error__cta(inputs)
	return pt_bookmark__iti_save_error__cta(inputs)
};